import { FormInput, FormTextArea } from "../../../helpers/AdminHelper";
import { memo } from "react";

const SeoSection = ({ project, updateSeo, inputClass }) => {
  return (
    <div className="space-y-6">
      <FormInput
        label="Meta Title"
        placeholder="Write meta title here"
        className={inputClass}
        value={project.seo.metaTitle}
        onChange={(e) => updateSeo("metaTitle", e.target.value)}
      />

      <FormInput
        label="Meta Description"
        placeholder="Write meta description here"
        className={inputClass}
        value={project.seo.metaDescription}
        onChange={(e) => updateSeo("metaDescription", e.target.value)}
      />

      <FormInput
        label="Meta Tags"
        placeholder="cctv, security, surveillance"
        className={inputClass}
        value={project.seo.metaTags}
        onChange={(e) => updateSeo("metaTags", e.target.value)}
      />

      <p className="text-xs text-gray-400">Separate tags with commas.</p>

      <FormTextArea
        label="Schema Script (JSON-LD)"
        rows={4}
        className={inputClass}
        value={project.seo.schemaScript}
        onChange={(e) => updateSeo("schemaScript", e.target.value)}
        placeholder={`{
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "CCTV Solution"
}`}
      />
    </div>
  );
};

export default memo(SeoSection);
